var editIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#7F91A5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M4.63 15H1v-3.63L11.37 1 15 4.63 4.63 15zM9 3.5l2 2\"/>\n</svg>";

export { editIcon as default };
